import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#e8eaed" viewBox="0 -960 960 960">
      <path fill={props.fill || '#1D252D'} d="M560-240l-56-58 142-142H160v-80h486L504-662l56-58 240 240-240 240z"></path>
    </svg>
  );
}

export default Icon;
